<mat-card class="mb-25 tagus-card">
    <mat-card-header class="border-bottom">
        <h5 class="mb-0">Sales Analytics</h5>
        <button type="button" mat-button class="position-relative btn bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
            This Week
        </button>
        <mat-menu #monthMenu="matMenu" class="monthMenu" xPosition="before">
            <button mat-menu-item type="button" class="bg-transparent border-none">This Month</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">This Year</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">All Time</button>
        </mat-menu>
    </mat-card-header>
    <mat-card-content>
        <div class="chart salesAnalyticsChart">
            <apx-chart
                [series]="chartOptions.series!"
                [chart]="chartOptions.chart!"
                [dataLabels]="chartOptions.dataLabels!"
                [plotOptions]="chartOptions.plotOptions!"
                [responsive]="chartOptions.responsive!"
                [xaxis]="chartOptions.xaxis!"
                [grid]="chartOptions.grid!"
                [yaxis]="chartOptions.yaxis!"
                [legend]="chartOptions.legend!"
                [colors]="chartOptions.colors!"
                [fill]="chartOptions.fill!"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>